import { Col, Row, Statistic } from 'antd';
import { format } from 'date-fns';
import type { TaskStatisticsOutputDto } from '../model';

function renderRangeTime(range_time: [number, number] | undefined) {
  if (!range_time) {
    return '--';
  }

  const [start_time, end_time] = range_time;
  const to_date = (timestamp: number) => {
    return new Date(timestamp < 10_000_000_000 ? timestamp * 1000 : timestamp);
  };

  const format_time = (date: Date) => {
    return format(date, 'yyyy-MM-dd HH:mm');
  };

  return `${format_time(to_date(start_time))} ~ ${format_time(to_date(end_time))}`;
}

export function TaskStatisticsSummary(props: {
  data: TaskStatisticsOutputDto | undefined;
}) {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={4}>
        <Statistic title="视频总数" value={props.data?.videos ?? 0} />
      </Col>
      <Col xs={24} md={4}>
        <Statistic title="脚本总数" value={props.data?.scripts ?? 0} />
      </Col>
      <Col xs={24} md={4}>
        <Statistic title="图片生成总数" value={props.data?.images ?? 0} />
      </Col>
      <Col xs={24} md={4}>
        <Statistic title="信用点总数" value={props.data?.cost ?? 0} />
      </Col>
      <Col xs={24} md={8}>
        <Statistic
          title="统计区间"
          value={renderRangeTime(props.data?.range_time)}
        />
      </Col>
    </Row>
  );
}
